<mat-card>
  <mat-card-header>
    <mat-card-title>Anfragen & Buchungen</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <p>Hier die zusammengefassten Daten Deiner Reisebuchungen, bitte überprüfe diese und gib uns bei Unstimmigkeiten
      sofort Bescheid:
    </p>
    <ng-container *ngIf="items && items.buchungen.length; else noBuchungen">
      <table class="table">
        <tr>
          <th>Reise</th>
          <th *ngIf="items.mehrereTeilnehmer">Teilnehmer</th>
          <th>Kategorie</th>
          <th>Zustieg</th>
          <th *ngIf="items.kurseGebucht">Guiding</th>
          <th>Status</th>
          <th>Ändern</th>
          <th>Zimmerwunsch</th>
        </tr>
        <tr *ngFor="let buchung of items.buchungen">
          <td>{{buchung.reise.dateString}} {{buchung.reise.name}}</td>
          <td *ngIf="items.mehrereTeilnehmer">{{buchung.teilnehmer.name()}}</td>
          <td>{{buchung.kategorie | name}}</td>
          <td>
            <ng-container *ngIf="buchung.reise.zustiege">
              <select *ngIf="buchung.reise.isZustiegAenderbar" [(ngModel)]="buchung.zustieg" required
                      (ngModelChange)="service.buchungAendern(buchung)">
                <option *ngFor="let zustieg of buchung.reise.zustiege" [ngValue]="zustieg">{{zustieg.zeit}} {{zustieg.ort}}</option>
              </select>
              <div *ngIf="!buchung.reise.isZustiegAenderbar">{{buchung.zustieg.zeit}} {{buchung.zustieg.ort}}</div>
            </ng-container>
          </td>
          <td *ngIf="items.kurseGebucht">{{buchung.kurs ? buchung.kurs.name : null}}</td>
          <td>{{buchung.status}}</td>
          <td>
            <button mat-button color="primary" (click)="service.buchungStornieren(buchung)" type="button"
                    *ngIf="buchung.isStatusChangeSupported('storniert') && buchung.reise.isStornierbar">Stornieren</button>
          </td>
          <td>{{buchung.zimmerwunsch}}</td>
        </tr>
      </table>
      <div [hidden]="!items.kurseGebucht" class="alert alert-info">
        {{service.texte.hinweiseGuiding()}}
      </div>
    </ng-container>
    <ng-template #noBuchungen>
      <p>Keine Anfragen oder Buchungen vorhanden.</p>
    </ng-template>
  </mat-card-content>
</mat-card>
